(function ($) {
    var validateObj = {};
    var colModel = [];
    var pageParams = {};
    var actiontype = null;
    var quickactionObj = null;
    var quickactionBtns = null;
    var dataObj = [];
    var selIds = null;
    var siteType = null;
    var showAppend = [];
    var showDelete = [];
    var container = null;
    var commentObj = {
        column: {
            name: 'comments',
            label: 'Internal Comments',
            edittype: 'textarea',
            editable: true,
            config: {}
        }
    };
    var emailcheckObj = {
        column: {
            name: 'sendQAEmail',
            label: 'Send Email',
            edittype: 'checkbox',
            editable: true,
            config: {}
        }
    };
    var errorWrapper = '<div data-container="error" id="ez-error-msg-container" style="display: none"></div>';
    var template = null;
    var multiVal = false;

    var reset = function () {
        // closeCommentPopover();
    };

   var getColumn = function (obj) {
      var editable = obj.editable;
      if (!obj.value) {
        editable = true;
      }
        return {
            name: obj.field,
            edittype: obj.fieldType,
            editable: editable,
            label: obj.label,
            metadata: obj.options,
            config: obj.config,
            value: obj.value,
            groupName: obj.groupName
        };
    };

    var getData = function () {
        var arr = [];
        var selectAll = $('#selectAll').is(':checked');

        if (selectAll) {
            selIds = getAllItemIds();
            selIds = selIds.split(',');
        }
        $.each(selIds, function (i, id) {
            arr.push($("#grid").jqGrid('getRowData', id));
        });
        
        return arr;
    };

    var getValue = function (column) {
        var type = column.edittype;
        var name = column.name;
        var value = '';
        var quickLength = dataObj.length;
        var curVal = '';
        multiVal = false;

        if (quickLength > 0 && dataObj[0].hasOwnProperty(name)) {
            value = getColDataString(type, dataObj[0][name], name);
            if (quickLength >= 1) {
                for (var i = 1; i < quickLength; i++) {
                    curVal = getColDataString(type, dataObj[i][name], name);
                    multiVal = value !== curVal;
                    if ((!value && curVal) || multiVal) {
                        value = '';
                        break;
                    }
                }
            }
        }

        return value || '';

    };

    var getAction = function (column) {
        var config = column.config || {};
        var name = column.name;

        if (!column.value) {
            if (!config.showAppend && $.inArray(name, showAppend) !== -1) {
                config.showAppend = true;
            }
            if (!config.showDelete && $.inArray(name, showDelete) !== -1) {
                config.showDelete = true;
            }
        }

    };

    var buttons = function (type, isEZAnalytics) {
        var content = '';
        var classes = 'btn btn-default inline-button-spacing';

        if (actiontype == 'publish') {
            content += $('<button>', {
                type: 'button',
                class: classes,
                id: 'test_config',
                text: 'Enter Credentials',
                onclick: 'testConfigClick()'
            }).prop('outerHTML');
        }
        
        $.each(quickactionBtns, function (i, mval) {
            var id = $.ezdia.sanitizer.specialChar(mval);
            content += $('<button>', {
                type: 'button',
                name: mval,
                class: classes,
                id: id,
                text: mval,
                'data-loading-text': 'Updating...',
                'data-quick-action-button-type': mval,
                'data-qa-type': type,
                'data-isEzAnalytics' : isEZAnalytics
            }).prop('outerHTML');

        });

        content += $('<button>', {
            type: 'button',
            class: 'btn btn-link',
            id: 'bulkUpdateReset',
            html: 'Reset',
            onclick: 'resetQuickAction($(this))',
            'data-loading-text': 'Reset...'
        }).prop('outerHTML');

        return $('<div>', {
            class: 'ezdia-form-btns',
            id: 'ezdia-bulk-edit-form-btns',
            html: content
        });

    };

    var getSiteObj = function () {
        var obj = {
            options: {}
        };

        $.each(siteType, function (key) {
            obj.options[key] = key;
        });

        return obj;
    };

    var helperTextContainer = function (text) {
        var content = '<i class="fa fa-info-circle"></i> ' + text;
        var callout = $('<div>', {
            class: 'ez-callout ez-callout-warning',
            html: content
        });

        container.prepend(callout);
    };

    var groupContainer = function(fieldsObj) {
        var arr = [];
        var grpArray = [];

        $.each(fieldsObj, function (key, col) {
            var grp = col.groupName || 'default';

            if ($.inArray(grp, arr) == -1) {
                arr.push(grp);
                grpArray.push({
                    name: grp,
                    label: grp
                });
            }

        });

        if ($.inArray('default', arr) === -1) {
            grpArray.push({
                name: 'default',
                label: 'default'
            });
            arr.push('default');
        }

        var grp = $.ezdia.groupFormField.create(grpArray);

        container.html(grp);
        $('#ez-sys-form-tabs').html($.ezdia.groupFormField.tabs(grpArray));
    };

    var appendContent = function (actiontype, name) {
        var elem = $('[name=' + name + ']');
        var appendAction = elem.data('appendAction');
        var parent = elem.closest('[data-row="input"]');
        var type = parent.data('type');
        var id = elem.attr('id');
        var value = '';

        if (actiontype == 'append' && !appendAction) {
            if (type == 'tag') {
                value = $('#ez-hidden_reset_value-' + name).val();
                $.each(value.split(','), function(index, value) {
                    elem.tagsinput('remove', value);
                });
            } else {
                resetVales(type, name, elem, id, '');
            }
            elem.data('appendAction', true);
        } else if (appendAction) {
            value = $('#ez-hidden_reset_value-' + name).val();
            resetVales(type, name, elem, id, value);
            elem.data('appendAction', false);
        }

        elem.trigger('cusappend');

    };

    var deleteContent = function(actiontype, name){
        var elem = $('[name=' + name + ']');
        var deleteAction = elem.data('deleteAction');
        var parent = elem.closest('[data-row="input"]');
        var multiWrap = parent.find('[data-action="multiple values"]');

        if (actiontype == 'delete' && !deleteAction) {
            toggleDisableFields(elem, true);
            multiWrap.addClass('disable');
        } else if (deleteAction) {
            toggleDisableFields(elem, false);
            multiWrap.removeClass('disable');
        }
    };

    var toggleDisableFields = function(elem, action){
        var parent = elem.closest('[data-row="input"]');
        var type = parent.data('type');
        var id = elem.attr('id');

        switch(type) {
            case 'html':
                $.ezdia.html.toggle(id, action);
                break;
            case 'slider':
                $.ezdia.slider.toggle(id, action);
                break;
            case 'multichoice':
                $.ezdia.multichoice.toggle(id, action);
                break;
            case 'inputlist':
            case 'groupField':
                $.ezdia.listInput.toggle(id, action, type);
                break;
            case 'inputTab':
                toggleDisableFieldsDefault(elem, action);
                break
            case 'date':
                $.ezdia.date.toggle(id, action);
                break;
            case 'checkbox':
                toggleDisableFieldsDefault(elem, action);
                break;
            case 'group':
            case 'role':
                $.ezdia.typehead.toggle(id, action, type);
                break;
            case 'status':
            case 'country':
            case 'singlechoice':
            case 'visualstatus':
            case 'dropdown':
                $.ezdia.singlechoice.toggle(id, action);
                break;
            case 'combo':
            case 'tag':
                toggleDisableFieldsDefault(elem, action);
                break;
            case 'filetype':
            case 'file':
                toggleDisableFieldsUpload(id, action);
                break;
            case 'inline':
                $.ezdia.inline.delValue({
                    element: elem,
                    action: action
                });
                break;
            case 'segment':
                $.ezdia.segments.delValue({
                    element: elem,
                    action: action
                });
                break;
            case 'creativebrief':
                $.ezdia.creativeBrief.delValue({
                    element: elem,
                    action: action
                });
                break;
            default:
                toggleDisableFieldsDefault(elem, action);
                break;
        };

        elem.data('deleteAction', action)
            .trigger('cusdelete');
    };

    var toggleDisableFieldsUpload = function (id, action) {
        var elem = $('#upload_' + id);
        var btn = elem.nextAll('[type="button"][value="Upload"]');

        if (action) {
            elem.attr('disabled', 'disabled');
        } else {
            elem.removeAttr('disabled');
        }
    };

    var toggleDisableFieldsDefault = function (elem, action) {
        if (action) {
            elem.attr('disabled', 'disabled');
        } else {
            elem.removeAttr('disabled');
        }
    };

    var resetMultiVal = function(elem){
        elem.removeClass('form-control-options-multiple')
            .addClass('form-control-has-multiple-values');
    };

    var getMultichoiceVal = function(str){
        return str ? str.split('##').join(', ') : '';
    };

    var getGroupValue = function(config, value){
        var label = value;

        if(config.options) {
            label = config.options[value] || value;
        }

        return label;
    };

    var setGroupValue = function(elem, column, value){
        var config = column.config || {};
        var label = getGroupValue(config, value);

        elem.val(value);
        $('#'+ (column.id || column.name)).typeahead('val', label);
    };

    var resetAdditionalOptionsMenu = function () {
        var self = $(this);
        var parent = self.closest('[data-row="row"]');
        var multiple = parent.data('multiple');
        var name = self.data('name');
        var value = $('#ez-hidden_reset_value-' + name).val();
        var type = parent.find('[data-row="input"]').data('type');
        var elem = $('[name=' + name + ']');
        var id = elem.attr('id');

        self.closest('li').siblings().removeClass('active')
            .find('input[type="checkbox"]').prop('checked', false);
        parent[0].className = parent[0].className.replace(/form-control-options-[a-zA-Z]+/g, '');

        deleteContent('', name);
        appendContent('', name);
        resetVales(type, name, elem, id, value);

        if (multiple) {
            resetMultiVal(parent);
        }

    };

    var resetVales = function (type, name, elem, id, value) {

        switch(type) {
            case 'slider':
                elem.bootstrapSlider('setValue', parseInt(value));
                setSliderValue(id, value);
                break;
            case 'multichoice':
                setMultichoiceVal(value, elem, id);
                break;
            case 'inputlist':
            case 'groupField':
                elem.inputList('refresh', value);
                break;
            case 'inputTab':
                elem.inputTab('refresh', value);
                break
            case 'date':
                elem = $('#' + name);
                elem.val(value).trigger('change');
                break;
            case 'checkbox':
                $.ezdia.checkbox.restore({column: {}, value: value});
                break;
            case 'group':
                setGroupValue(elem, {}, value);
                break;
            case 'combo':
            case 'tag':
                $.each(value.split(','), function(index, value) {
                    elem.tagsinput('add', value);
                });
                break;
            case 'filetype':
            case 'file':
                $.ezdia.upload.refresh({
                    name: name,
                    value: value
                });
                break;
            case 'inline':
                $.ezdia.inline.setValue({
                    element: elem,
                    value: value
                });
                break;
            case 'segment':
                $.ezdia.segment.setValue({
                    name: name,
                    value: value
                });
                break;
            case 'creativebrief':
                $.ezdia.creativeBrief.setValue({
                    element: elem, 
                    value: value
                });  
                break;              
            default:
                elem.val(value);
                break;
        };

        elem.trigger('change');

    };

    var additionalOptionsMenu = function(){
        var self = $(this);
        var prefix = 'form-control-options-';
        var addCls = '';
        var removeCls = '';
        var parent = self.closest('[data-row="row"]');
        var name = self.data('id');
        var actiontype = self.data('actiontype');

        if (this.checked) {
            self.closest('li').addClass('active')
                .siblings().removeClass('active')
                .find('input[type="checkbox"]').prop('checked', false);

            if (actiontype == 'append') {
                addCls = prefix + 'append';
                removeCls = prefix + 'delete';
            } else {
                addCls = prefix + 'delete';
                removeCls = prefix + 'append';
            }

            parent.removeClass(removeCls);
            parent.addClass(addCls);
            resetMultiVal(parent);

        } else {
            self.closest('li').removeClass('active');
            parent[0].className = parent[0].className.replace(/form-control-options-[a-zA-Z]+/g, '');
        }

        deleteContent(actiontype, name);
        appendContent(actiontype, name);

    };

    $.extend(this, {
        quickAction: {
            load: function (id, type, containerId, frmName, rowsdata, isEZAnalytics) {
                frmName = frmName || 'bulkEditFrm';
                validateObj = {};
                $.ezdia.form.init();
                colModel = [];
                template = $.ezdia.template.get('quick-action-form-row', {'form-row-additional-options': 'form-row-additional-options'});
                pageParams = $.ezdia.config.pageParams;
                actiontype = type;
                quickactionObj = pageParams.quickactionObj;
                selIds = getGridSelRow();
//                dataObj = pageParams.tab == 'MyTask' ? getData() : []; removing check of page comparison since it's hindering the roles to be shown
                dataObj = rowsdata || getData();
                container = $("#" + (containerId || 'quickactionfield'));

                var self = this;
                var selectAll = $('#selectAll').is(':checked');

                $.ezdia.widgets.load(actiontype);
                reset();

//                if (!selectAll && (!selIds || selIds.length == 0)) {
//                    alert("Error", "Please select at least one item");
//                    return;
//                }

                showAppend = getCustomConfig('show_append');
                showDelete = getCustomConfig('show_delete');

                hideShowDeskForm('#bulkEditFrm');
                container.empty();

                $(quickactionObj).each(function (i, obj) {
                    var fields = null;
                    if (actiontype == obj.name) {
                        quickactionBtns = obj.btnlabel ? obj.btnlabel.split('##') : [];
                        fields = obj.quickActionFields;
                        groupContainer(fields);

                        if (obj.helperText) {
                            helperTextContainer(obj.helperText);
                        }

                       self.create(fields, obj.config);
                    } else {

                    }
                });

                var btns = buttons.call(this, type, isEZAnalytics);

                container.append(errorWrapper);
                container.append(btns);
                ezdia.component.form.show();
                this.btnActions(quickactionObj, frmName);
                $.ezdia.desk.getMetaObj({
                    ids: id,
                    widgets: $.ezdia.widgets.options[actiontype]
                });
                $.ezdia.validate.create(validateObj, frmName);
                $.ezdia.widgets.create(actiontype);
                $.ezdia.postrender.load(actiontype, colModel);
                $.ezdia.groupFormField.hide(actiontype);
                $('#ez-desk-form-group-collapse-link-wrapper, #ez-desk-form-actions-wrapper').show();
                this.fieldsAdditionalOptions();
                $.ezdia.stickyFormBtns({
                    sticky: 'ezdia-bulk-edit-form-btns',
                    frm: 'bulkEditFrm'
                });
                var scrollOpt = {
                    clickable: true
                };
                
                if (pageParams.formType !== 'desk') {
                    scrollOpt = {
                        clickable: true,
                        pageHeader: '#ez-page-top-navbar',
                        sticky: '#ez-desk-form-actions-wrapper'
                    };
                }
                
                $('#bulkEditFrm').isDirty();
                
                $('#ez-scroll-nav-pills').scrollingNav(scrollOpt);
            },
            create: function (fieldsObj, config) {
                var self = this;
                var inputs = '';

                $.each(fieldsObj, function (key, col) {
                    var content = '';
                    var obj = {};
                    inputs = '';
                    
                    if(col.entity){
                        obj.column = $.extend({}, col, {
                            editable: false,
                            id: col.entity.name,
                            name: col.entity.name
                          });
                    }else if (col.fieldType) {
                        obj.column = getColumn(col);
                    } else {
                        obj.column = col;
                    }
                    obj.column.id = 'ez-quick-action-inputs-' + obj.column.name;
                    obj.value = col.value;
                    //obj.column.action = getAction(obj.column);
                    obj.column.config = $.ezdia.getFieldsConfig(obj.column);
                    getAction(obj.column);

                    if (obj.column.edittype == 'multichoice' && obj.column.name == 'sys_publish_sites') {
                        siteType = getSiteName();
                        obj.column.config = getSiteObj();
                        obj.column.afterSelect = $.ezdia.integration.valiadtePubSite;
                    }
                    
                    if (obj.value && !obj.column.editable) {
                        inputs = '<div class="form-control-static">' + $.ezdia.inputs.readonlyView(obj) + $.ezdia.inputs.hiddentext(obj) +  '</div>';
                        multiVal = false;
                    } else {
                        obj.value = getValue(obj.column) || obj.value;
                        inputs = $.ezdia.inputs.create(obj, actiontype);
                        $.ezdia.validate.init(validateObj, obj.column);
                    }

                    obj.column.values = obj.value;
                    obj.column.multiVal = multiVal;

                    content = obj.column.edittype === 'hidden' ? inputs : self.markup(inputs, obj);
                    $.ezdia.groupFormField.append(obj.column.groupName, content);
                    $.ezdia.widgets.init(obj, actiontype);
                    colModel.push(obj.column);
                    buildShowHistoryLink(obj.column.name, obj.column.label, obj.column.config, obj.column.edittype, true);
                });

                if (config && config.email_config) {
                    inputs = '<div class="checkbox"><label><input type="checkbox" name="sendQAEmail" id="sendQAEmail"/></label></div>';
                    $.ezdia.groupFormField.append('', this.markup(inputs, emailcheckObj));
                }

                if (pageParams.roleType == 'pm') {
                    inputs = $.ezdia.inputs.textarea(commentObj);
                    $.ezdia.groupFormField.append('', this.markup(inputs, commentObj));
                }
                createFieldActionLink();
            },
            markup: function(inputs, obj){
                var content = '';
                content = template(obj.column);
                content = $(content);
                content.find('[data-row="input"]').append(inputs);

                return content;
            },
            fieldsAdditionalOptions: function(){
                $('[data-checkbox="devfieldOption"]').on('click', function(){
                    additionalOptionsMenu.call(this);
                });

                $('li[data-action="reset"]').on('click', function(){
                    resetAdditionalOptionsMenu.call(this);
                });

                $('[data-action="multiple values"]').on('click', function(){
                    var self = $(this);

                    if (self.hasClass('disable')) {
                        return;
                    }

                    self.closest('[data-row="row"]').addClass('form-control-options-multiple')
                        .removeClass('form-control-has-multiple-values');
                });

            },
            btnActions: function (QAObj, frmName){
                var btns = container.find('button[type=button][data-quick-action-button-type]');
                var frm = $('#' + frmName);
                
                $.each(btns, function(){
                    var elem = $(this);
                    var label = elem.data('quickActionButtonType');
                    var qaType = elem.data('qaType');
                    
                    $.each(QAObj, function(i, obj) {
                        var btnsArray = obj.btnlabel ? obj.btnlabel.split("##") : [];
                        if(btnsArray.indexOf(label) !== -1 && qaType === obj.name) {
                            elem.data('QAObj', obj);
                            return false;
                        }
                    });
                    
                });
                
                btns.on('click', function(event) {
                    var obj = $(this).data('QAObj');
                    var min = obj.minItems;
                    var max = obj.maxItems;
                    var isEzAnalytics =  $(this).attr("data-isEzAnalytics");
                    
                    var rangeObj = {
                        min: min,
                        max: max
                    };
                    
                    if ($.ezdia.quickLinks.notInRange(rangeObj)) {
                        return false;
                    }
                    
                    if (!frm.valid()) {
                        return false;
                    }
                    
                    submitQuickAction(event, obj, isEzAnalytics);
                });
            },
            markInvoiced: function(id, type) {
                var notUnique = false;
                var response = {
                    sowDetails: null,
                    success: true
                };
                var selectAllIsChecked = $('#selectAll').is(':checked');
                
                if (selectAllIsChecked) {   
                    var searchString = $('#searchFrm').search('getQueryString');
                    $.ajax({
                        type: "POST",
                        url: 'getInvoiceDetails.htm',
                        data: {
                            formtype: $.ezdia.config.pageParams.formType,
                            searchCondition: searchString
                        },
                        dataType: 'json',
                        async: false,
                        success: function(res) {
                            response = res;
                        },
                        error: function() {
                            result = '';
                        }
                        
                    })
                    
                } else {
                    var grid = $('#grid');
                    var ids = ezdia.util.getSelectedGridItemsByGridId();
                    var dsowName = '';

                    $.each(ids, function(i, id){
                        var sowName = grid.jqGrid('getCell', id, 'sow_name') || '-----';
                        if (!dsowName) {
                            dsowName = sowName;
                        } else if(dsowName && dsowName !== sowName) {
                            notUnique = true;
                            return false;
                        }
                    });  
                }
                if (selectAllIsChecked && !response.success) {
                    alert('Error', response.msg);
                    return false;
                } else if (notUnique) {
                    alert('Error', "Please select items from a single SOW.");
                    return false;
                }
                var rowdata = response.sowDetails ? [response.sowDetails] : null;
                $.ezdia.quickAction.load(id, type, '', '', rowdata);
                return true;
            }
        }
    });
    
    $.extend(this, {
       ezQuickAction: {
           load : function () {
               
           },
           create : function (elem) {
                var label = unescape(elem.data('label'));
                var qaType = elem.data('type');
                template = $.ezdia.template.get('quick-action-form-row', {'form-row-additional-options': 'form-row-additional-options'});
                var obj;

                $.each($.ezdia.config.pageParams.quickactionObj, function(i, element) {
                    var btnsArray = element.title ? element.title.split("##") : [];
                    if(btnsArray.indexOf(label) !== -1 && qaType === element.name) {
                        obj = element;
                    }
                });
                
                var frm = $("#bulkEditFrm");
                $("#quickactionfield").empty();
                
                var quickactionObj = $.ezdia.config.pageParams.quickactionObj;
                
                $(quickactionObj).each(function (i, obj) {
                    var fields = null, inputs, row;
                    if (qaType == obj.name) {
                        fields = obj.quickActionFields;
                        $.each(fields, function (key, col) {
                            row = "<input type='hidden' id=' " + obj.name + "-"  + key  + "' name='" + key +"' value='" + col.value + "' data-type='hidden'>";
                            $("#quickactionfield").append(row);
                        });
                        
                    }
                });

                submitQuickAction(event, obj, true);
           }
       } 
    });
    
}).apply($.ezdia, [jQuery]);

(function ($) {
    var pageParams = {};
    var template = null;
    var wrapper = null;
    var rowwrapper = null;
    var row = null;
    var account = [];
    var role = [];
    var count = 0;
    var saveCounts = 0;
    var clickEventType = 'sys_assignment_limit';


    var reset = function() {
        hideShowDeskForm('#assignment-limit-form');
        selectQuickActionLink('assignmentLimitLi');
        wrapper.empty();
        count = 0;
        account = [];
    };

    var getAccount = function(){
        var allAccountsStr = pageParams.allAccountsExceptExpertMgt;

        if (!allAccountsStr && ezdia.config.user) {
          allAccountsStr = ezdia.config.user.all_accounts_except_expert_mgt || '';
        }

        var acc = allAccountsStr.split(',');

        $.each(acc, function(i, val){
            var arr = [];
            if (val) {
                arr = val.split('=');
                account.push({
                    value: arr[0].trim(),
                    label: arr[1] || arr[0]
                });
            }
        });
    }

    var getRole = function(counter, data){
        role = [];
        var accName = data ? data.accountName : '';
        var roleValue = data ? data.role : '';
        var accountName = accName || $('#accountName' + counter).val();
        var content = '';

        if (!accountName) {
            return content;
        }

        var context = "&accountName=" + accountName;

        $.ajax({
            type: "POST",
            url: "AssignmentLimitAccess.htm",
            data: context,
            dataType: 'json',
            async: false,
            success: function(response) {
                $.each(response, function(value, label) {
                    role.push({
                        value: value,
                        label: label,
                        selected: (value == roleValue)
                    });
                });
            }
        });

        if (content) {
            return content;
        }

    };

    var addrow = function(){
        createRow();
    };

    var removerow = function(){
        var elem = $(this);
        var rows = null;

        elem.closest('tr[data-row="row"]').remove();

        rows = rowwrapper.find('[data-assignment-limit-type="remove"]');

        if (rows.length == 1) {
            rows.attr('disabled', disabled);
        }
    };

    var events = function(){
        wrapper.off('click.' + clickEventType);
        
        wrapper.on('click.' + clickEventType, '[data-assignment-limit-type="add"]', function(){
            addrow();
        }).on('click.' + clickEventType, '[data-assignment-limit-type="remove"]', function(){
            removerow.call(this);
        });

        wrapper.on('change.' + clickEventType, 'select[data-assignment-limit-type="account"]', function(){
            var index = $(this).data('index');
            var opt = $.ezdia.template.get('base-form-type-select-options');
            var context = null;

            getRole(index);
            context = opt({options: role});
            $("#role" + index).empty().append(context);
            sortAccountName('role'+index);
        });

        $('#updateAssignmentLimitBtn').on('click.' + clickEventType, update);
        $('#resetLimitLink').on('click.' + clickEventType, resetAssignmentLimit);

    };

    var widget = function(){
        var obj = {decimal: false};
        var accelem = $('#accountName'+count);
        var roleelem = $('#role'+count);

        sortAccountName('accountName'+count);
        sortAccountName('role'+count);

        $('#assignmentLimit'+count).numeric(obj);
        $('#lifetimeLimit'+count).numeric(obj);
        $('#reworkPercentage'+count).numeric(obj);

        if (accelem.find('option').length > 5) {
            accelem.selectmenu();
        }

        roleelem.selectmenu();
    };

    var createRow = function(data){
        data = data || {};
        getRole(count, data);

        var context = {
            index: count,
            accounts: account,
            account: data.accountName,
            role: role,
            limit: data && data.assignmentLimit != -1 ? data.assignmentLimit : '',
            lifeLimit: data && data.lifetimeLimit != -1 ? data.lifetimeLimit : '',
            reworkPercentage: data && data.reworkPercentage != -1 && data.reworkPercentage != 0? data.reworkPercentage : ''
        };
        var content = row(context);

        rowwrapper.append(content)
        widget();
        count++;
    };

    var populateSavedRows = function(data){
        if (data) {
            $.each(data, function(key, value){
                createRow(value);
            });
        }
    };

    var getAssignmentLimitString = function(){
        var arr = [];
        var rows = rowwrapper.find('tr');

        $.each(rows, function(){
            var elem = $(this);
            var index = elem.data('index');
            var accVal = $('#accountName' + index).val();
            var roleVal = $("#role" + index).val();
            var limitVal = $("#assignmentLimit" + index).val() || -1;
            var lifeLimitVal = $("#lifetimeLimit" + index).val() || -1;
            var reworkVal = $("#reworkPercentage" + index).val() || -1;

            if (!accVal || !roleVal || (!limitVal && lifeLimitVal == -1 && !reworkVal)) {
                return true;
            }

            arr.push({
                accountName: accVal,
                role: roleVal,
                assignmentLimit: limitVal,
                lifetimeLimit: lifeLimitVal,
                reworkPercentage: reworkVal,
                timeSpan: 0,
                createdByRole: pageParams.role,
                createdBy: pageParams.email,
                id: -1,
                type: ''
            });

        });

        return (arr.length) ? JSON.stringify(arr) : null;
    };

    var resetAssignmentLimit = function(){
        $.ezdia.assignmentLimit.create();
    };

    var update = function(){
        var activeBtn = $(this);
        activeBtn.button('loading');
        var userNameList = {};
        var queryString = '';
        var selIds = getGridSelRow();

        $.each(selIds, function(i){
            var rowData = $("#grid").jqGrid('getRowData', selIds[i]);
            var id = parseInt(getDataFromString(rowData['username']));
            var email = getDataFromString(rowData['email']);
            userNameList[id] = email;
        });

        queryString = getAssignmentLimitString();

        if (!queryString) {
            dialog("Please provide Limit or Lifetime Limit or Rework Percentage for selected projects");
            activeBtn.button('reset');
            return;
        }

        $.ajax({
            type: "POST",
            url: 'SaveAssignmentLimit.htm',
            datatype: 'json',
            data: {
                query: queryString,
                userName: JSON.stringify(userNameList),
                timeLimit: false
            },
            success: function(data) {
                dialog(data.SUCCESS);
            },
            error: function(data) {
                dialog(data);
            }
        }).always(function () {
            activeBtn.button('reset');
        });

    };

    var dialog = function(msg){
        $("#statusMsg").html(msg);
        $("#statusMsg").dialog({
            modal: true,
            width: '300',
            height: 200,
            title: "Save Assignment Limit",
            buttons: {
                Ok: function() {
                    $(this).dialog("close");
                }
            }
        });

    };

    $.extend(this, {
        assignmentLimit: {
            load: function(){
                pageParams = $.ezdia.config.pageParams;
                template = $.ezdia.template.get('sys-assignment-limit');
                row = $.ezdia.template.get('sys-assignment-limit-rows');
                wrapper = $('#assignmentLimitRowGroup');

                reset();
                getAccount();

                var selIds = getGridSelRow();
                var selectAll = $('#selectAll').is(':checked');
                if (!selectAll && (!selIds || selIds.length == 0)) {
                    alert("Error", "Please select at least one item");
                    return;
                }
                
                ezdia.component.form.show();
                wrapper.html(template());
                rowwrapper = wrapper.find('#assignmentLimitRows');

                if(selIds.length == 1) {
                    var rowData = $("#grid").jqGrid('getRowData', selIds);
                    var id = getDataFromString(rowData['username']);
                    var data = "&userName=" + id;
                    data += "&timeLimit="+false;
                    $.ajax({
                        type: "POST",
                        url: "GetAllAssignmentLimits.htm",
                        data: data,
                        dataType: 'json',
                        async: false,
                        success: function(response) {
                            populateSavedRows(response);
                        }
                    });
                }

                saveCounts = count;
            },
            create: function(){
                this.load();
                createRow();
                events();
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {
    var pageParams = {};
    var template = null;
    var wrapper = null;
    var timeSpanId = 'ez-js-sys-time-span-input';
    var limitId = 'ez-js-sys-assignment-time-limit-input';
    var resetSelection = function() {
        hideShowDeskForm();
        selectQuickActionLink('assignmentLimitLi');
        wrapper.empty();
    };
    
    var getSavedValue = function (selIds) {
	var data = $("#grid").jqGrid('getRowData', selIds);
	var id = getDataFromString(data['username']);
        var returnVal = {};
        
	$.ajax({
	    type: "POST",
	    url: "GetAllAssignmentLimits.htm",
	    data: "&userName=" + id + "&timeLimit=" + true,
	    dataType: 'json',
	    async: false,
	    success: function(response) {
		if (response) {
                    returnVal = response;
                } 
	    },
            error: function (err) {
                returnVal = {};
            }
	});   
        
        return returnVal;
    };
    
    var submit = function () {
        var timeLimit = $("#" + timeSpanId).val();
        var assignmentLimit = $("#" + limitId).val();
        
        if (!timeLimit || !assignmentLimit) {
            alert("Error", "Please provide both time span and assignment limits");
            return;
        } else if (isNaN(timeLimit) || isNaN(assignmentLimit)) {
            alert("Error", "Please provide integer values for time span and assignment limits");
            return;
        }
        
        pageParams = $.ezdia.config.pageParams;
        
        var activeBtn = $(this);
            activeBtn.button('loading');
        
        var userNameList = {};
        var selIds = getGridSelRow();
        
        $.each(selIds, function(i){
            var rowData = $("#grid").jqGrid('getRowData', selIds[i]);
            var id = parseInt(getDataFromString(rowData['username']));
            var email = getDataFromString(rowData['email']);
            userNameList[id] = email;
        });
        
        $.ajax({
            type: "POST",
            url: 'SaveAssignmentLimit.htm',
            datatype: 'json',
            data: {
                query: function() {
                    var jsonvalue = [{
                        accountName: '',
                        role: '',
                        lifetimeLimit: -1,
                        assignmentLimit: assignmentLimit,
                        timeSpan: timeLimit,
                        createdByRole: pageParams.role || $("#role").val(),
                        createdBy: pageParams.email,
                        id: -1,
                        type: ''
                    }];
                
                    return JSON.stringify(jsonvalue);
                },
                userName: JSON.stringify(userNameList),
                timeLimit: true
            },
            success: function(data) {
                alert("Save Checkout Limit", data.SUCCESS);
            },
            error: function(data) {
                alert("Save Checkout Limit", data);
            }
        }).always(function () {
          activeBtn.button('reset');
        });
    };
    
    var resetValues = function () {
        $("#" + timeSpanId).val('');
        $("#" + limitId).val('');
    };
    
    var actions = function () {
        wrapper.find('#ez-js-sys-assignment-time-limit-submit-btn').on('click', submit);
        wrapper.find('#ez-js-sys-assignment-time-limit-reset-btn').on('click', resetValues);
        
        $.ezdia.stickyFormBtns({
            sticky: 'ezdia-bulk-edit-form-btns',
            frm: 'assignmentTimeLimitDiv'
        });
    };
    
    this.assignmentTimeLimit = {
        load: function () {
            pageParams = $.ezdia.config.pageParams;
            template = $.ezdia.template.get('sys-assignment-time-limit');
            wrapper = $('#assignmentTimeLimitDiv');
            resetSelection();
            $().scrollingNav('destroy', 'ez-scroll-nav-pills');
        },
        create: function () {
            var isRowSelected = $.ezdia.grid.isRowSelected();
            var content = '';
            var context = {};
            
            if (!isRowSelected) {
                return;
            }
            ezdia.component.form.show();
            this.load();
            
            context = isRowSelected.length === 1 ? getSavedValue(isRowSelected) : {};
            content = template(context['##'] || {});
                    
            wrapper.html(content).show();
            
            $.ezdia.integer.create([{
                id: timeSpanId
            }, {
                id: limitId
            }]);
        
            actions();
        }
    };
    
}).apply($.ezdia, [jQuery]);

(function ($) {
    var pageParams = {};
    var template = null;
    var wrapper = null;
    
    var resetSelection = function() {
        hideShowDeskForm();
        selectQuickActionLink('assignmentLimitLi');
        wrapper.empty();
    };
    
    var getSavedValue = function (isRowSelected) {
	var rowData = $("#grid").jqGrid('getRowData', isRowSelected);
	var id = getDataFromString(rowData['username']);
        var email = getDataFromString(rowData['email']);
	var data = "&uid=" + id;
        data += "&email=" + email;    
        var returnVal = {};
        
	$.ajax({
	    type: "POST",
	    url: "FetchOpenProjForUser.htm",
	    data: data,
	    dataType: 'json',
            async: false,
	    success: function(response) {
                if (!$.isEmptyObject(response)) {
                    returnVal = response;
                } else {
                    returnVal = {
                        norecord: true
                    };
                }
            },
            error: function () {
                
            }
	});   
        
        return returnVal;
    };

    this.quickActionOpenProject = {
        load: function () {
            pageParams = $.ezdia.config.pageParams;
            template = $.ezdia.template.get('sys-quick-action-open-project');
            wrapper = $('#allOpenProjectsDiv');
            resetSelection();
            $().scrollingNav('destroy', 'ez-scroll-nav-pills');
        },
        create: function () {
            var isRowSelected = $.ezdia.grid.isRowSelected();
            var content = '';
            var context = {};
            
            if (!isRowSelected) {
                return;
            }
            ezdia.component.form.show();
            this.load();
            
            context = isRowSelected.length === 1 ? getSavedValue(isRowSelected) : {};
            content = template(context);
                    
            wrapper.html(content).show();
        
            //actions();
        }
    };  
    
    var getCompletedBatches = function () {
	var returnVal = {};
        
	$.ajax({
	    type: "POST",
	    url: "getCompletedBatches.htm",
	    data: '',
	    dataType: 'json',
            async: false,
	    success: function(response) {
                if (!$.isEmptyObject(response)) {
                    returnVal = response;
                } else {
                    returnVal = {
                        norecord: true
                    };
                }
            },
            error: function () {
                
            }
	});   
        
        return returnVal;
    };
    
    this.quickActionInvoiceBatch = {
        create: function (qaDivId) {
            pageParams = $.ezdia.config.pageParams;
            qaDivId = qaDivId || 'quickactionfield';
            var template = $.ezdia.template.get('sys-quick-action-invoice-batch');
            var content = '';
            var context = {};
            ezdia.component.form.show();
            hideShowDeskForm('#bulkEditFrm');
            
            context = getCompletedBatches();
            content = template(context);
                    
            $('#'+qaDivId).html(content);
            ezdia.component.form.show();

        }
    };  
}).apply($.ezdia, [jQuery]);

(function ($) {
    var QATYPE = 'ez.quickActionOpenProjectDefRule';
    var pageParams = {};
    var template = null;
    var wrapper = null;
    var fieldsName = {
        TEXTAREA: 'quick_action_open_project_def_rule',
        ACCOUNT: 'accountName',
        ROLE: 'role',
        ORDERID: 'orderId',
        PROJECTTYPE: 'projectType',
        COLVALUE: 'colValue'
    };
    
    var groupColumn = [{
        editable: true,
        edittype: 'group',
        name: fieldsName.ORDERID,
        label: 'Order Id'
    }, {
        editable: true,
        edittype: 'group',
        name: fieldsName.PROJECTTYPE,
        label: 'Project Type'
    }];
    
    var resetSelection = function() {
        hideShowDeskForm();
        selectQuickActionLink('assignmentLimitLi');
        wrapper.empty();
    };
    
    var getcolumn = function () {
        var allAccountsStr = pageParams.allAccountsExceptExpertMgt;
        var allAccounts;
        var accountOptions = {};

        if (!allAccountsStr && ezdia.config.user) {
          allAccountsStr = ezdia.config.user.all_accounts_except_expert_mgt
        }
        
        if(allAccountsStr) {
            allAccounts = allAccountsStr.split(",");
            $.each(allAccounts, function (i, str) {
                var arr = str.split('=');
                var key = arr[0] || '';
                var value = arr[1] || '';
                
                accountOptions[key] = value;
                
            });
        }
        
        return {
            edittype: 'groupField',
            editable: true,
            name: fieldsName.TEXTAREA,
            label: '',
            config: {
                fields: [{
                    editable: true,
                    edittype: 'singlechoice',
                    name: fieldsName.ACCOUNT,
                    label: 'Account Name',
                    config: {
                        deselect: false,
                        options: accountOptions
                    }
                }, {
                    editable: true,
                    edittype: 'singlechoice',
                    name: fieldsName.ROLE,
                    label: 'Role',
                    config: {
                        deselect: false,
                        options: []
                    }
                }, 
                groupColumn[0],
                groupColumn[1], {
                    editable: true,
                    edittype: 'text',
                    name: fieldsName.COLVALUE,
                    label: 'Additional Condition'
                }]
            }
        };
    };
    
    var getSelector = function (name) {
        return '[id^=' + fieldsName.TEXTAREA + '_' + fieldsName[name] + ']';;
    };
    
    this.quickActionOpenProjectDefRule = {
        QATYPE : 'ez.quickActionOpenProjectDefRule',
        fieldsName : {
            TEXTAREA: 'quick_action_open_project_def_rule',
            ACCOUNT: 'accountName',
            ROLE: 'role',
            ORDERID: 'orderId',
            PROJECTTYPE: 'projectType',
            COLVALUE: 'colValue'
        },
        wrapper : "openProjDefRuleform",
        column: {},
        groupColumn : [{
            editable: true,
            edittype: 'group',
            name: 'orderId',
            label: 'Order Id'
        }, {
            editable: true,
            edittype: 'group',
            name: 'projectType',
            label: 'Project Type'
        }],
        load: function () {
            pageParams = $.ezdia.config.pageParams;
            template = $.ezdia.template.get('sys-quick-action-open-project-def-rules');
            wrapper = $('#openProjDefRuleform');
            resetSelection();
            $.ezdia.widgets.load(this.QATYPE);
            $().scrollingNav('destroy', 'ez-scroll-nav-pills');
        },
        create: function () {
            var query = $('#searchFrm').search('getQueryString');
            var inputs = '';
            var context = '';
            var content = '';
            var obj = {};
            
            if (!query) {
                alert("Error", "Please provide valid search criteria!!");
                return false;
            }
            ezdia.component.form.show();
            this.load();
            
            this.column = !$.isEmptyObject(this.column) ? this.column : getcolumn();
            obj = {
                column: this.column
            };
            
            inputs =  $.ezdia.inputs.textarea(obj, true);
            context = {
                content: $.ezdia.inputs.rowMarkup('', obj.column, inputs).prop('outerHTML')
            };
            content = template(context);
            
            wrapper.append(content).show();
                    
            $.ezdia.widgets.init(obj, this.QATYPE);
            $.ezdia.widgets.create(this.QATYPE);
            
//            this.actions();
        
        },
        getSelector : function (name) {
            return '[id^=' + this.fieldsName.TEXTAREA + '_' + this.fieldsName[name] + ']';;
        },
        
        actions : function() {
            var table = $("#" + this.wrapper).find('table');
            var ACCOUNT = this.getSelector('ACCOUNT');
            var ROLE = this.getSelector('ROLE');

            table.on('change.' + this.QATYPE, 'select' + ACCOUNT, this.accountChange);
            table.on('change.' + this.QATYPE, 'select' + ROLE, this.roleChange);

            var wrapper = $("#" + this.wrapper);
            wrapper.find('#ez-js-sys-quick-action-open-project-def-rules-btn').on('click', this.save);
            wrapper.find('#ez-js-sys-quick-action-open-project-def-rules-reset-btn').on('click', this.reset);

            $.ezdia.stickyFormBtns({
                sticky: 'ezdia-bulk-edit-form-btns',
                frm: 'openProjDefRuleform'
            });
        },
        accountChange : function() {
            var parent = $.ezdia.quickActionOpenProjectDefRule.getParent.call(this);
            var obj = {
                account: this.value.trim(),
                parent: parent
            };

             $.ezdia.quickActionOpenProjectDefRule.setRowOptions(obj);
        }, 
        roleChange : function() {
            var parent = $.ezdia.quickActionOpenProjectDefRule.getParent.call(this);
            var ACCOUNT =  $.ezdia.quickActionOpenProjectDefRule.getSelector('ACCOUNT');
            var account = parent.find('select' + ACCOUNT).val();

            var obj = {
                account: account.trim(),
                role: this.value.trim(),
                parent: parent
            };

             $.ezdia.quickActionOpenProjectDefRule.setRowOptions(obj, true);

        },
        setRowOptions : function (obj, role) {
            var data = this.getRowOptions(obj);

            if (!role) {
                var roleSelector = this.getSelector('ROLE');
                var roleElem = obj.parent.find('select' + roleSelector).empty();

                $.ajax({
                    type: "POST",
                    url: "AssignmentLimitAccess.htm",
                    data: "&accountName=" + obj.account,
                    dataType: 'json',
                    async: false,
                    success: function(response) {
                        $.each(response, function(key, mval) {
                            if (key && key.trim()) {
                                var options = $('<option>', {
                                    value: key,
                                    text: mval
                                });
                            } else {
                                return true;
                            }
                            roleElem.append(options);
                        });
                    }
                });
                roleElem.trigger("chosen:updated").trigger('change');
            } else {
                $.each(data, function (key, value) {
                    var col = {
                        options: value,
                        parent: obj.parent
                    };

                    $.ezdia.widgets.load($.ezdia.quickActionOpenProjectDefRule.QATYPE);

                    if (key === 'order_id') {
                        col.column = $.ezdia.quickActionOpenProjectDefRule.groupColumn[0];
                        col.selctor = 'ORDERID';
                    } else if (key === 'project_type') {
                        col.column = $.ezdia.quickActionOpenProjectDefRule.groupColumn[1];
                        col.selctor = 'PROJECTTYPE';
                    }

                    $.ezdia.quickActionOpenProjectDefRule.setGroupOptions(col);
                });
            }
        },
        setGroupOptions : function (obj) {
            var column = obj.column;
            var elemSelector = this.getSelector(obj.selctor);
            var elem = obj.parent.find(elemSelector+'.tt-input');
            var elemH = obj.parent.find(elemSelector+'[name]');
            var id = elem.attr('id');
            var options = obj.options;

            elem.typeahead("destroy");

            if (typeof options === 'string' && options.indexOf('##') !== -1) {
                column.metadata = options;
                column.config = null;
            } else {
                column.config = options;
            }
            column.id = id;

            $.ezdia.getFieldsConfig(column);

            $.ezdia.widgets.init({
               column: column 
            }, this.QATYPE);

            $.ezdia.widgets.create(this.QATYPE);

            elem.typeahead('val', '');
            elemH.val('').trigger('change');

        },

        getParent : function () {
            return $(this).closest('[data-row="groupFields"]');
        },
        getRowOptions : function (obj) {
            var data = "&assignment_tool_name=" + obj.account;
            var returnVal = [];

            if (obj.role) {
                data += "&assignment_role_name=" + obj.role;
            }

            $.ajax({
                type: "POST",
                url: "GetAllGroupFields.htm",
                data: data,
                dataType: 'json',
                async: false,
                success: function(response) {
                    returnVal = response;
                }
            });

            return returnVal;

        },
        save : function () {
            var activeBtn = $(this);
            activeBtn.button('loading');
            var searchString = getSearchQueryString();
            var defaultRule = '';
            var defaultRuleArray = [];

            if (!searchString) { 
                alert("Error", "Please provide valid search criteria!!");
                activeBtn.button('reset');
                return;
            }

            defaultRule = $('#' + fieldsName.TEXTAREA).val();
            defaultRule = $.ezdia.getJsonObject(defaultRule) || [];

            if (defaultRule.length) {
                $.each(defaultRule, function (i, obj) {
                    if (obj.accountName && obj.role) {
                        defaultRuleArray.push(obj);
                    }
                });
            } else {
                alert("Error", "Please provide valid search criteria!!");
                activeBtn.button('reset');
                return;
            }

            $.ajax({
                type: "POST",
                url: 'AddDefaultRule.htm',
                datatype: 'json',
                data: {
                    defaultRule: JSON.stringify(defaultRuleArray),
                    assignRule: searchString,
                    assignment_tool_name: 'expert',
                    assignment_role_name: 'pm'
                },
                success: function(data) {
                    alert("Save Default Rule", data);
                },
                error: function(data) {
                    alert("Save Default Rule", data);
                }
            }).always(function () {
                activeBtn.button('reset');
            });       
        },
        reset : function () {
            $.ezdia.quickActionOpenProjectDefRule.create();
        }
    };
}).apply($.ezdia, [jQuery]);

(function ($) {
    var config;

    $.extend(this, {
        widgets: {
            load: function (type) {
                this.options = this.options || {};
                this.options[type] = {
                    text: {},
                    editor: {},
                    slider: {},
                    actionLink: {},
                    listInput: {},
                    inputtab: {},
                    json: {},
                    date: {},
                    url: {},
                    brief: {},
                    comment: {},
                    singlechoice: [],
                    multichoice: [],
                    group: [],
                    tag: [],
                    tabletype: [],
                    integer: [],
                    boolean: [],
                    entity: {},
                    inputCount: {},
                    inline: {},
                    upload: {},
                    category: {},
                    attributes: {},
                    segment: {},
                    compute: {},
                    checkbox:{},
                    entityLabel: []
                };
            },
            renderAll: function(colModal, type){
                var self = this;
                this.load(type);
                $.each(colModal, function(i, column){
                    $.ezdia.getFieldsConfig(column);
                    self.init({
                        column: column
                    }, type);
                });
                this.create(type);
            },
            init: function (obj, type) {
                var options = this.options[type];
                var column = obj.column;

                if (!options) {
                    return false;
                }

                if (column.entity) {
                    $.ezdia.entity.init(options.entity, {
                        column:column,
                        value:column.editable ? '' : obj.value
                    });
                }
                
                if (column.config && column.config.count) {
                    $.ezdia.inputCount.init(options.inputCount, {
                        column:column
                    });
                }

                if (column.config && column.config.compute) {
                    $.ezdia.compute.init(options.compute, {
                        column:column,
                        value:column.editable ? '' : obj.value
                    });
                }
                
                switch (column.edittype) {
                    case 'composite':
                        this.composite(obj);
                        break;
                    case 'html':
                        $.ezdia.html.init(options.editor, obj);
                        break;
                    case 'status':
                    case 'country':
                    case 'singlechoice':
                    case 'visualstatus':
                    case 'dropdown':
                        column.options = $.ezdia.singlechoice.getOptions(options.singlechoice, options.group, obj);
                        break;
                    case 'multichoice':
                        column.options = $.ezdia.multichoice.init(options.multichoice, obj);
                        break;
                    case 'slider':
                        $.ezdia.slider.init(options.slider, obj);
                        break;
                    case 'inputlist':
                    case 'groupField':
                        $.ezdia.listInput.init(options.listInput, obj);
                        break;
                    case 'attributes':
                        $.ezdia.attributes.init(options.attributes, obj);
                        break;
                    case 'group':
                        $.ezdia.typehead.init(options.group, obj);
                        break;
                    case 'role':
                        if (column.config && column.config.url) {
                            $.ezdia.typehead.init(options.group, obj);
                        }
                        break;
                    case 'tag':
                    case 'combo':
                        $.ezdia.tagInput.init(options.tag, obj);
                        break;
                    case 'date':
                        $.ezdia.date.init(options.date, obj);
                        break;
                    case 'inputtab':
                        $.ezdia.inputTab.init(options.inputtab, obj);
                        break;
                    case 'json':
                        options.json[obj.column.id || obj.column.name] = obj;
                        break;
                    case 'textarea':
                        //obj.metadata = $.ezdia.textarea.get(obj);
                        break;
                    case 'filetype':
                    case 'file':
                        $.ezdia.upload.init(options.upload, obj);
                        break;
                    case 'integer':
                        $.ezdia.integer.init(options.integer, obj);
                        break;
                    case 'boolean':
                        $.ezdia.boolean.init(options.boolean, obj);
                        break;
                    case 'url':
                        $.ezdia.url.init(options.url, obj);
                        break;
                    case 'creativebrief':
                        $.ezdia.creativeBrief.init(options.brief, {
                            name: column.name,
                            key: column.id || column.name,
                            value: obj.value,
                            editable: column.editable
                        });
                        break;
                    case 'comment':
                        $.ezdia.comment.init(options.comment, obj);
                        break;
                    case 'inline':
                        $.ezdia.inline.init(options.inline, obj);
                        break;
                    case 'category':
                        $.ezdia.category.init(options.category, obj);
                        break
                    case 'segment':
                        $.ezdia.segment.init(options.segment, obj);
                        break
                    case 'checkbox':
                        $.ezdia.checkbox.init(options.checkbox, obj);
                        break
                    case 'entityLabel':
                        $.ezdia.entityLabeling.init(options.entityLabel, obj);
                        break;
                    default:
                        $.ezdia.textbox.init(options.text, obj);
                        break
                }
            },
            create: function (type) {
                var options = this.options[type];

                if (!options) {
                    return false;
                }

                $.each(options, function (key, obj) {
                    if (!$.isEmptyObject(obj)) {
                        switch (key) {
                            case 'json':
                                $.ezdia.jsonFields.create(obj);
                                break;
                            case 'editor':
                                $.ezdia.html.create({editor: obj});
                                break;
                            case 'slider':
                                $.ezdia.slider.create(obj);
                                break;
                            case 'actionLink':
                                $.ezdia.fieldActionLinks.action(obj);
                                break;
                            case 'date':
                                $.ezdia.date.create(obj);
                                break;
                            case 'singlechoice':
                                $.ezdia.singlechoice.create(obj);
                                break;
                            case 'multichoice':
                                $.ezdia.multichoice.create(obj);
                                break;
                            case 'group':
                                $.ezdia.typehead.create(obj);
                                break;
                            case 'tag':
                                $.ezdia.tagInput.create(obj);
                                break;
                            case 'listInput':
                            case 'groupField':
                                $.ezdia.listInput.create(obj, 'div[data-input="list"]');
                                break;
                            case 'attributes':
                                $.ezdia.attributes.create(obj);
                                break;
                            case 'inputtab':
                                $.ezdia.inputTab.create(obj, 'div[data-input="list"]');
                                break;
                            case 'tabletype':

                                break;
                            case 'upload':
                                $.ezdia.upload.create(obj);
                                break;
                            case 'integer':
                                $.ezdia.integer.create(obj);
                                break;
                            case 'boolean':
                                $.ezdia.boolean.create(obj);
                                break;
                            case 'url':
                                $.ezdia.url.create(obj);
                                break;
                            case 'brief':
                                $.ezdia.creativeBrief.create(obj);
                                break;
                            case 'comment':
                                obj['_list'] = $.ezdia.config.pageParams.itemMetaInfo || ezdia.config.metadata.comments || {};
                                $.ezdia.comment.create(obj);
                                break;
                            case 'inline':
                                $.ezdia.inline.create(obj);
                                break;
                            case 'category':
                                $.ezdia.category.create(obj);
                                break;
                            case 'segment':
                                $.ezdia.segment.create(obj);
                                break
                            case 'checkbox':
                                $.ezdia.checkbox.create(obj);
                                break
                            case 'text':
                                $.ezdia.textbox.create(obj);
                                break;
                            case 'entityLabel':
                                $.ezdia.entityLabeling.create(obj);
                                break;
                            default:
                                break;
                        }
                    }

                });

                if (!$.isEmptyObject(options.entity)) {
                    $.ezdia.entity.create(options.entity);
                }
                
                if (!$.isEmptyObject(options.inputCount)) {
                    $.ezdia.inputCount.create(options.inputCount);
                }

                if (!$.isEmptyObject(options.compute)) {
                    ezdia.widgets.compute.createAll(options.compute);
                }

            }
        }
    });
}).apply($.ezdia, [jQuery]);


(function ($) {
    var template = null;
    var pageParams = $.ezdia.config.pageParams;
    var countryArray = ["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas, The", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "British Virgin Is.", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Rep.", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Dem. Rep.", "Congo, Repub. of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia, The", "Gaza Strip", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Fed. St.", "Moldova", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "N. Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Helena", "Saint Kitts & Nevis", "Saint Lucia", "St Pierre & Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome & Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Is", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands", "Wallis and Futuna", "West Bank", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];

    var status = function (select, obj) {
        var value = obj.value;

        $(pageParams.statuses).each(function (i, mval) {
            var status = mval && mval.trim();
            if (!status) {
                return;
            }

            var options = $('<option>', {
                value: status,
                text: status
            });

            if (value == status) {
                options.attr('selected', 'selected');
            }

            select.append(options);
        });

        return select;
    };

    var country = function (select, obj) {
        var value = obj.value;

        $.each(countryArray, function (i, mval) {

            var options = $('<option>', {
                value: mval,
                text: mval
            });

            if (value == mval) {
                options.attr('selected', 'selected');
            }

            select.append(options);

        });

        return select;
    };

    var getOptions = function (select, obj) {
        var column = obj.column;
        var config = column.config || {};
        var value = obj.value ? obj.value.split('##') : [];

        if (config.options) {
            $.each(config.options, function (key, mval) {
                if (key && key.trim()) {
                    var options = $('<option>', {
                        value: key,
                        text: mval
                    });
                    var index = $.inArray(key, value);
                    if (index !== -1) {
                        options.attr('selected', 'selected');
                         value.splice(index, 1);
                    }

                } else {
                    return true;
                }

                select.append(options);

            });
            if (value.length && column.edittype == "multichoice") {
                $.each(value, function(i, mval) {
                    if (mval && mval.trim()) {
                        var options = $('<option>', {
                            value: mval,
                            text: mval,
                            "data-other": 'other'
                        });
                        options.attr('selected', 'selected');
                        select.append(options);
                    }
                });
            }
        }

        return select;
    };

    var getSelectedCheck = function (value, arr) {
        var val = false;

        if ($.inArray(value, arr) !== -1) {
            val = true;
        }

        return val;
    };

    var getOptionsArray = function (config, value, id) {
        var arr = [];
        var valueArray = '';

        if (value != '' && value != null) {
            value = String(value);
            valueArray = value.split('##');
        }

        if (config.options) {
            $.each(config.options, function (key, mval) {
                if (!key) {
                    return;
                }
                arr.push({
                    label: mval,
                    key: key,
                    value: key,
                    checked: valueArray ? getSelectedCheck(key, valueArray) : false
                });
            });
        }

        return arr;
    };

    var getTextboxsVal = function(value, column){

        if (value) {
            switch (column.edittype) {
                case 'date':
                    value = $.ezdia.date.view(column.config, value);
                    break;
                case 'role':
                case 'group':
                    value = $.ezdia.typehead.view(value, column.config);
                    break;
                default:
                    break;
            }
        }

        return value || '';
    };

    var getFiletypeData = function(data) {
        var context = {
            data: []
        };
        var template = $.ezdia.template.get('base-form-type-upload-url-partial');

        if (!data) {
            return false;
        }

        $.each(data.split(','), function(i, mval){
            var obj = {
                href: mval.split("#")[0],
                value: mval.replace("#", "")
            };
            var ext = obj.href.split('.').pop().toLowerCase();

            if ($.inArray(ext, ['gif','png','jpg','jpeg', 'tif', 'webp']) !== -1) {
                obj.type = 'img';
                obj.title = obj.value;
                obj.src = obj.href;
            }

            context.data.push(obj);
        });

        return template(context);
    };

    var getClasses = function(column, helper){
        var cssCls = '';
        var config = column.config || {};

        if (helper){
            cssCls += ' '+helper;
        }

        if (column.edittype == 'html' && !column.editable) {
            cssCls += ' readonly-html';
        }

        if (config.cssCls) {
            cssCls += ' '+config.cssCls;
        }

        if (config.videoHelp) {
            //videoHelp = metadata.videoHelp.join(':');
        }

        return cssCls;
    };
    
    $.extend(this, {
        inputs: {
            create: function (obj, type) {
                var column = obj.column;
                var content = '';

                column.config = $.ezdia.getFieldsConfig(column);

                switch (column.edittype) {
                    case 'textarea':
                    case 'html':
                    case 'inputlist':
                    case 'groupField':
                    case 'inputtab':
                    case 'json':
                    case 'comment':
                    case 'attributes':
                        content = this.textarea(obj);
                        break;
                    case 'entityLabel':
                        content = this.textarea(obj, true);
                        break;
                    case 'status':
                    case 'country':
                    case 'singlechoice':
                    case 'visualstatus':
                    case 'dropdown':
                        content = this.singlechoice(obj);
                        break;
                    case 'multichoice':
                        content = this.multichoice(obj);
                        break;
                    case 'comment':
                        content = $.ezdia.commentField.create({
                            column: column,
                            value: obj.value
                        });
                        break;
                    case 'slider':
                        content = this.slider(obj);
                        break;
                    case 'radio':
                    case 'checkbox':
                        content = this.radioCheck(obj);
                        break;
                    case 'hidden':
                        content = this.hiddentext(obj);
                        break;
                    case 'date':
                        content = this.date(obj);
                        break;
                    case 'boolean':
                        content = this.boolean(obj);
                        break;
                    case 'role':
                        if (!column.editable) {
                            content = '<div id="' + column.id + '">' + obj.value + '</div>';
                        } else if (column.config && column.config.url) {
                            content = this.textboxs(obj);
                        } else {
                            content = this.textbox(obj);
                        }
                        break;
                    case 'group':
                        if (!column.editable) {
                            content = '<div class="form-control-static" id="' + column.id + '">' + $.ezdia.typehead.view(obj.value, column.config) + '</div>';
                        } else {
                            content = this.textboxs(obj);
                        }
                        break;
                    case 'category':
                        content = this.textboxs(obj);
                        break;
                    case 'hidden':
                        content = this.hiddentext(obj);
                        break;
                    case 'filetype':
                    case 'file':
                        content = this.filetype(obj);
                        break;
                    case 'inline':
                        content = $.ezdia.inline.view(obj);
                        break;
                    case 'segment':
                        content = $.ezdia.segment.view(obj);
                        break;
                    default:
                        if (column.entity && !column.editable) {
                            content = '<div id="' + column.id + '">' + obj.value + '</div>';
                        } else {
                            content = this.textbox(obj);
                        }
                        break;
                }

                return content;
            },
            getMarkup: function(frmObj, actiontype, template){

                var rowTemplate = template || $.ezdia.template.get('base-form-row');
                var inputs = $.ezdia.inputs.create(frmObj, actiontype);
                var row = $.ezdia.inputs.rowMarkup(rowTemplate, frmObj.column, inputs);

                return row;
            },
            rowMarkup: function(template, column, inputs){
                var row = '';
                var rowTemplate = template || $.ezdia.template.get('base-form-row');

                if (column.edittype != 'hidden') {
                    var helper = $.ezdia.helperText(column);
                    column.classes = getClasses(column, helper.classes);
                    column.helpInfo = helper.content;

                    row = rowTemplate(column);
                    row = $(row);
                    row.find('[data-row="input"]').prepend(inputs);
                } else {
                    row = inputs;
                }

                return row;
            },
            readonlyView: function (obj, type, template) {
                var column = obj.column;
                var value = obj.value;
                var content = '';
                
                column.config = $.ezdia.getFieldsConfig(column) || {};

                if (column.name == 'tool_name' || column.name == 'project_type') {
                    content = $.ezdia.getAccountName(value);
                } else {
                    switch(column.edittype) {
                        case 'hidden':
                            content = $.ezdia.inputs.hiddentext(obj);
                            break;
                        case 'multichoice':
                            content = $.ezdia.multichoice.view(value, column);
                            break;
                        case 'inputlist':
                            content = $.ezdia.listInput.view(obj, type);
                            break;
                        case 'groupField':  
                            obj.preview = true;
                            content = $.ezdia.listInput.view(obj, type);
                            break;   
                        case 'attributes':  
                            obj.preview = true;
                            content = $.ezdia.attributes.view(obj, type);
                            break;   
                        case 'tag':
                        case 'combo':
                            content = $.ezdia.tagInput.view(column, value);
                            break;
                        case 'date':
                            var format = column.config.format;
                            content = $.ezdia.date.view({format: format}, value);
                            break;
                        case 'file':
                        case 'filetype':
                            content = $.ezdia.upload.view({column: column, value: value});
                            break;
                        case 'segment':
                            content = $.ezdia.segment.view({column: column, value: value});
                            break;
                        case 'url':
                            content = $.ezdia.url.view({column: column, value: value});
                            break;
                        case 'singlechoice':
                            content = $.ezdia.singlechoice.view({column: column, value: value});
                            break;
                        case 'checkbox':
                            content = $.ezdia.checkbox.view({column: column, value: value});
                            break;
                        case 'category':
                            content = $.ezdia.category.view({column: column, value: value});
                            break;
                        case 'creativebrief':
                            content = this.textarea(obj);
                            break;
                        case 'radio':
                            content = $.ezdia.radio.view({column: column, value: value});
                            break;
                        case 'slider':
                            content = $.ezdia.radio.view({column: column, value: value});
                            break;
                        case 'status':
                            content = $.ezdia.status.view({column: column, value: value});
                            break;
                        case 'entityLabel':
                            content = $.ezdia.status.view({column: column, value: value});
                            break;
                        default:
                            content = value;
                            break;
                    }
                    
                    if (column.entity && typeof column.entity === 'string') {
                        column.entity = $.ezdia.getJsonObject(column.entity);
                    }
                        
                    if (column.entity && column.entity.viewAccess) {
                        setTimeout(function() {
                            var entityObj = {};
                            $.ezdia.entity.init(entityObj, obj);
                            $.ezdia.entity.create(entityObj, obj);
                        });
                    }
                }

                return template ? this.rowMarkup(template, column, content) : content;

            },
            hiddentext: function (obj){
                var column = obj.column;
                var prop = {
                    type: 'hidden',
                    id: column.id || column.name,
                    name: column.name,
                    value: obj.value || '',
                    'data-type': column.edittype
                }

                if (column.path) {
                    prop['data-path'] =  column.path;
                }

                var content = $('<input>', prop);
                
                return content.prop('outerHTML');
            },
            textbox: function (obj, hide) {
                var column = obj.column;
                var config = column.config || {};
                var classes = config.cssClass || '';
                var value = obj.value;
                
                if (value && column.edittype === 'integer') {
                    value = value.match(/\d+|\./g);
                    value = value.join('');
                }
                
                var prop = {
                    type: 'text',
                    id: column.id || column.name,
                    name: column.name,
                    value: (value || value === 0) ? value : '',
                    class: 'form-control ' + classes,
                    placeholder: column.placeholder || '',
                    'data-type': column.edittype,
                    'data-for':column.label
                };

                if (!obj.column.editable || obj.column.readonly) {
                    prop.readonly = true;
                }

                if (column.path) {
                    prop['data-path'] =  column.path;
                }

                if (hide) {
                    prop.css = {
                        display: 'none'
                    };
                }
                
                var content = $('<input>', prop);
                
                return content.prop('outerHTML');
            },
            textboxs: function(obj) {
                var column = obj.column;
                    column.hiddenId = (column.id || column.name) + '-date-value';
                var config = column.config || {};
                var classes = config.cssClass || '';
                var value = obj.value;
                var prop = {
                    type: 'text',
                    name: column.name,
                    id: column.hiddenId,
                    class: classes,
                    value: (value || value === 0) ? value : '',
                    class: classes,
                    'data-for':column.label,
                    css: {
                        display: 'none'
                    }
                };

                if (column.path) {
                    prop['data-path'] =  column.path;
                }
                var col = Object.create(column);
                if(col.edittype == "singlechoice"){
                    col.edittype = "group";
                }
                var text = {
                    type: 'text',
                    id: column.id || column.name,
                    value: getTextboxsVal(value, col),
                    class: 'form-control ' + classes,
                    placeholder: column.placeholder || '',
                    'data-type': column.edittype
                };

                if (obj.column.readonly) {
                    text.readonly = true;
                }

                var content = $('<input>', prop).prop('outerHTML');
                    content += $('<input>', text).prop('outerHTML');

                return content;
            },
            textarea: function (obj, hide) {
                var column = obj.column;
                var config = column.config || {};
                var classes = config.cssClass || '';
                var value = obj.value || column.defaultvalue ||'';
                var content = '<textarea>' + value + '</textarea>';
                    content = $(content);
                    content.attr('id', (column.id || column.name))
                        .attr('name', column.name)
                        .attr('rows', config.rows || 4)
                        .attr('class', 'form-control ' + classes)
                        .attr('placeholder', column.placeholder || '')
                        .attr('data-type', column.edittype)
                        .attr('data-for', column.label);

                if (hide) {
                    content.css('display', 'none');
                }

                if (column.path) {
                    content.attr('data-path', column.path);
                }

                return content.prop('outerHTML');

            },
            textareas: function (obj) {
                var column = obj.column;
                var config = column.config || {};
                var classes = config.cssClass || '';
                var value = obj.value || column.defaultvalue || '';
                var visible_value = obj.visible_value || '';
                var textarea_hidden = '<textarea>' + value + '</textarea>';
                var textarea_visible = '<textarea>' + visible_value + '</textarea>';
                var content = '';
                var id = column.id || column.name;
                column.hiddenId = id + '-date-value';

                textarea_hidden = $(textarea_hidden);
                textarea_hidden.attr('id', column.hiddenId)
                    .attr('name', column.name)
                    .attr('data-visible-id', id)
                    .css('display', 'none')
                    .attr('data-for', column.label);

                textarea_visible = $(textarea_visible);
                textarea_visible.attr('id', id)
                    .attr('rows', config.rows || 4)
                    .attr('class', 'form-control ' + classes)
                    .attr('placeholder', column.placeholder || '')
                    .attr('data-hidden-id', column.hiddenId)
                    .attr('data-type', column.edittype);

                if (column.path) {
                    textarea_hidden.attr('data-path', column.path);
                }

                content = textarea_hidden.prop('outerHTML');
                content += textarea_visible.prop('outerHTML');

                return content;

            },
            singlechoice: function (obj) {
                pageParams = $.ezdia.config.pageParams;
                var column = obj.column;
                var config = column.config || {};

                if(config.userInput){
                    return this.textboxs(obj);
                }

                var classes = config.cssClass || '';
                var content = $('<select>', {
                    id: column.id || column.name,
                    name: column.name,
                    class: 'form-control ' + classes,
                    'data-type': column.edittype,
                    placeholder: column.placeholder,
                    'data-deselect': config.deselect,
                    'data-for':column.label
                });

                if (column.path) {
                    content.attr('data-path', column.path);
                }

                if (column.config && column.config.multiple) {
                    content.attr('multiple', 'multiple');
                }

                if (typeof config.blank === 'undefined' || config.blank) {
                    var option = $('<option>', {
                    });
                    content.append(option);
                }

                switch (column.edittype) {
                    case 'status':
                        status(content, obj);
                        break;
                    case 'country':
                        country(content, obj);
                        break;
                    default:
                        getOptions(content, obj);
                }

                return content.prop('outerHTML');

            },
            multichoice: function (obj) {
                var column = obj.column;
                var config = column.config || {};
                var classes = config.cssClass || '';
                var content = $('<select>', {
                    id: 'multichoice-' + (column.id || column.name),
                    multiple: 'multiple',
                    class: 'form-control ' + classes,
                    'data-type': column.edittype,
                    'data-for':column.label
                });

                if (column.path) {
                    content.attr('data-path', column.path);
                }

                getOptions(content, obj);

                content = content.prop('outerHTML') + this.textarea(obj, true);
                return content;

            },
            slider: function (obj) {
                var column = obj.column;
                var config = column.config || {};
                var classes = config.cssClass || '';
                var value = obj.value || 0;
                var content = $('<input>', {
                    type: 'text',
                    id: column.id || column.name,
                    name: column.name,
                    value: obj.value || '',
                    class: 'form-control ' + classes,
                    'data-type': column.edittype,
                    'data-color': config.color || config.setColor,
                    'data-slider-min': config.min,
                    'data-slider-max': config.max,
                    'data-slider-value': value,
                    'data-for':column.label
                });

                if (column.path) {
                    content.attr('data-path', column.path);
                }

                var span = $('<span>', {
                    class: 'badge',
                    text: value,
                    id: (column.id || column.name) + '_slider_value'
                }).prop('outerHTML');

                content = content.prop('outerHTML') + span;

                return content;
            },
            radioCheck: function (obj) {
                var content = '';
                var column = obj.column;
                var config = column.config || {};
                var value = obj.value || column.defaultvalue;
                var context = {
                    value: value,
                    edittype: column.edittype,
                    name: column.name,
                    id: column.id || column.name,
                    options: getOptionsArray(config, value),
                    path: column.path
                };
                
                var custome = obj.isCustomeUI ? '-custome' : '';
                var templateName = column.edittype === 'radio' ? 'base-form-radio-checkbox' + custome : 'base-form-checkbox';
                
                template = $.ezdia.template.get(templateName);
                
                return template(context) + content;
            },
            boolean: function (obj) {
                template = $.ezdia.template.get('base-form-boolean');
                var column = obj.column;
                var context = {
                    value: obj.value,
                    name: column.name,
                    id: column.id || column.name,
                    edittype: column.edittype
                };

                return template(context);
            },
            date: function (obj) {
                return this.textboxs(obj);
            },
            filetype: function(obj){
                return $.ezdia.upload.view(obj);
            },
            setValue: function (obj) {
                var edittype = obj.type || $(obj.id).data('type');

                switch (edittype) {
                    case 'html':

                        break;
                    case 'comment':

                        break;
                    case 'inputlist':
                    case 'groupField':

                        break;
                    case 'inputtab':

                        break;
                    case 'attributes':

                        break;
                    case 'status':
                    case 'country':
                    case 'singlechoice':
                    case 'visualstatus':
                    case 'dropdown':
                        $.ezdia.singlechoice.setValue(obj);
                        break;
                    case 'multichoice':

                        break;
                    case 'slider':

                        break;
                    case 'radio':
                    case 'checkbox':

                        break;
                    case 'hidden':

                        break;
                    case 'date':
                        $.ezdia.date.setValue(obj);
                        break;
                    case 'boolean':

                        break;
                    case 'role':

                        break;
                    case 'group':
                        $.ezdia.typehead.setValue(obj);
                        break;
                    case 'category':

                        break;
                    case 'hidden':

                        break;
                    case 'filetype':
                    case 'file':
                        $.ezdia.upload.refresh({
                            name: obj.id,
                            value: obj.value
                        });
                        break;
                    case 'segment':
                        $.ezdia.segment.setValue(obj);
                        break;
                    case 'inline':
                        $.ezdia.inline.setValue({
                            element: $('#' + obj.id),
                            value: obj.value
                        });
                        break;
                    default:
                        $(obj.id).val(obj.value);
                        break;
                }
            },
            qaView: function(data) {
                var template = $.ezdia.template.get('trial-multiple-qa-view');
                var array = $.ezdia.getJsonObject(data) || [];
                var content = '';
                
                $.each(array, function(i, question){
                    var options = [];
                    
                    $.each(question.options, function(key, label){
                        var classes = "";
                        
                        if (label.toLowerCase() === (question.correct_answer || '').toLowerCase()) {
                            classes = "text-success";
                        } else if (label.toLowerCase() === (question.answer || '').toLowerCase()) {
                            classes = "text-danger";
                        }
                        
                        options.push({
                            label: label,
                            classes: classes
                        });
                    });
                    
                    var obj = $.extend({}, question, {
                        options: options,
                        index: (i + 1)
                    });
                    
                    content += template(obj);
                });
                
                return content;
            }
        }
    });
}).apply($.ezdia, [jQuery]);
